<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <router-view />
    </a-locale-provider>
  </div>
</template>
<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import enUS from "ant-design-vue/lib/locale-provider/en_US";
import jaJP from "ant-design-vue/lib/locale-provider/ja_JP";
import moment from "moment";
import "moment/locale/zh-cn";
import "moment/locale/ja";
//english version
export default {
  data() {
    return {
      locale: enUS
    };
  },
  watch: {
    "$route.query.locale": function(val) {
      //this.locale = val === "enUS" ? enUS : zhCN;
      //moment.locale(val === "enUS" ? "en" : "zh-cn");
      this.locale = val;
      if(this.locale==='jaJP'){
        moment.locale('ja-jp');
      } else if(this.locale==='enUS'){
        moment.locale('en-us');
      } else if(this.locale==='zhCN'){
        moment.locale('zh-cn');
      }
    }
  }
};
</script>

<style lang="less">
#app {
  height: 100%;
}
</style>
